/*
 * Clase Account ExtendedProperty, clase utilizada
 * para las vista Account manager.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import moment from 'moment';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as accountExtendedPropertyActions from '../../actions/account_extended_property/index';

/* Style */
import '../../../../public/style/dashboard.scss';

/* Components */
import Header from '../../components/account_extended_property/header';
import Title from '../../components/account_extended_property/title';
import Table from '../../components/account_extended_property/table';
import Buttons from '../../components/account_extended_property/buttons';
import ModalCreate from '../../components/account_extended_property/modalCreate';
import ModalEdit from '../../components/account_extended_property/modalEdit';
import ModalDelete from '../../components/account_extended_property/modalDelete';
import Expired from '../expired/index';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';

class AccountExtendedProperty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalEdit: false,
      modalDelete: false,
      selectedFilter: "",
      types: ["DATE","TEXT"],
      crudTypes: ["person", "vehicle", "semiTrailer"],
      config: {
        name: '',
        type: '',
        crudType: ''
      }
    };
  }

  /*
   * In the DidMount state, the content is loaded, where the requested functions are:
   * fetchAccountExtendedPropertyApi (get list of extendeds)
   */
  async componentDidMount() {
    // call to the local store function with which we obtain the permissions
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('extendedproperties');
    // condition where we validate if we have the necessary settings and permissions
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('account')) {
          await this.props.actions.fetchAccountExtendedPropertyApi({});
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  /*
   * En estado WillUnmount se realiza un reset de los reducer
   * la funcion solicitada
   * resetAccountExtendedProperty(resetea el reducers)
   */
  componentWillUnmount() {
    this.props.actions.resetAccountExtendedProperty();
  }

  handleFilter = async event => {
    const select = event.target.dataset.select;
    document.getElementById('select-filter').innerHTML = 
      `${this.props.language.account.accountExtendedProperty.filter.show}: ${event.target.innerHTML}`;
    this.state.selectedFilter = select;
    await this.props.actions.fetchAccountExtendedPropertyApi({filter:select});
  };

  handleSelect = async event => {
    const element = event.currentTarget;
    const parent = element.dataset.parent;
    const id = element.id;
    const arr = document.querySelectorAll(`[id^='${parent}'] > li `);
    const arrArray = Array.from(arr);
    arrArray.forEach(item => {
      if (id != item.id) {
        item.classList.remove('select');
      }
    });
    element.classList.toggle('select');
  };

  handleSubmit = async event => {
    const objSett = JSON.parse(this.props.setting.value);
    const name = document.getElementById('name').value;
    var type = "";
    var crudType = "";

    for(var i=0;i<this.state.types.length; i++) {
      var item = this.state.types[i].toLowerCase();
      if (document.getElementById(`list-type-${item}`).classList.contains('select')) {
        type = document.getElementById(`list-type-${item}`).dataset.value;
      }
    }
    
    for(var i=0;i<this.state.crudTypes.length; i++) {
      var item = this.state.crudTypes[i].toLowerCase();
      if (document.getElementById(`list-owner-${item}`).classList.contains('select')) {
        crudType = document.getElementById(`list-owner-${item}`).dataset.value;
      }
    }

    const obj = {
      name: name,
      type: type,
      crudType: crudType
    };
    await this.props.actions.handleExtendedProperty({ extendedProperty: obj });
  };

  handleDelete = async event => {
    const id = document.getElementById('iddelete').value;
    await this.props.actions.handleDeleteExtendedProperty({ id: id });
  };

  handleUpdate = async event => {
    const objSett = JSON.parse(this.props.setting.value);
    const name = document.getElementById('nameup').value;    
    const id = document.getElementById('id').value;
    var type = "";

    for(var i=0;i<this.state.types.length; i++) {
      var item = this.state.types[i].toLowerCase();
      if (document.getElementById(`listup-type-${item}`).classList.contains('select')) {
        type = document.getElementById(`listup-type-${item}`).dataset.value;
      }
    }

    const obj = {
      name: name,
      type: type
    };
    await this.props.actions.handleUpdateExtendedProperty({ extendedProperty: obj, id: id });
  };

  handleModal = async e => {
    e.stopPropagation();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modal ? false : true;
      this.setState({ modal: reset });
      if (!reset) {
        this.props.actions.resetModalExtendedProperty();
        if (this.props.statusSave == 200) {
          this.state.selectedFilter = "";
          await this.props.actions.fetchAccountExtendedPropertyApi({});
        }
      }
    }
  };

  handleModalDelete = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDelete ? false : true;
      this.setState({ modalDelete: reset });
      if (!reset) {
        this.props.actions.resetModalExtendedProperty();
        if (this.props.statusSave == 200) {
          this.state.selectedFilter = "";
          await this.props.actions.fetchAccountExtendedPropertyApi({});
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        this.setState({
          config: {
            id: obj.id,
            name: obj.name,
            type: obj.dataType,
            crudType: obj.crud
          }
        });
      }
    }
  };

  handleModalEdit = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalEdit ? false : true;
      this.setState({ modalEdit: reset });
      if (!reset) {
        this.setState({
          config: {
            name: '',
            type: '',
            crudType: ''
          }
        });
        this.props.actions.resetModalExtendedProperty();
        if (this.props.statusSave == 200) {
          this.state.selectedFilter = "";
          await this.props.actions.fetchAccountExtendedPropertyApi({});
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);

        this.setState({
          config: {
            id: obj.id,
            name: obj.name,
            type: obj.dataType,
            crudType: obj.crud
          }
        });
      }
    }
  };

  handleChange = e => {
    let config = { ...this.state.config };
    config[e.target.dataset.update] = e.target.value;
    this.setState({
      config
    });
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      let container = '';

      const button = localStoreFN().getItem('permits');
      const buttonShow = button.includes('buttonextendedproperties');

      const header = (
        <Header language={this.props.language.filter} handleSearch={this.handleSearch} />
      );
      if (this.props.loading) {
        container = <Loading language={this.props.language} />;
      } else if (
        this.props.status === 401 ||
        this.props.statusSave === 401
      ) {
        container = <Expired history={this.props.history} language={this.props.language} />;
      } else if (
        this.props.status === 200
      ) {
        container = (
          <div className="main-container scroll">
            <Title language={this.props.language} />
            <Buttons
              buttonShow={buttonShow}
              handleModal={this.handleModal}
              handleFilter={this.handleFilter}
              selectedFilter={this.state.selectedFilter}
              language={this.props.language ? this.props.language : ''}
            />
            <Table
              buttonShow={buttonShow}
              handleFieldsFilter={this.handleFieldsFilter}
              loadingTable={this.props.loadingTable}
              datos={this.props.datos}
              handleModal={this.handleModalEdit}
              handleModalDelete={this.handleModalDelete}
              language={this.props.language ? this.props.language : ''}
            />
            <ModalCreate
              handleSelect={this.handleSelect}
              handleSubmit={this.handleSubmit}
              handleModal={this.handleModal}
              modal={this.state.modal}
              statusSave={this.props.statusSave}
              loadingSave={this.props.loadingSave}
              dataSave={this.props.dataSave}
              language={this.props.language ? this.props.language : ''}
              types={this.state.types}
              crudTypes={this.state.crudTypes}
            /> 
            <ModalEdit
              handleChange={this.handleChange}
              handleSelect={this.handleSelect}
              handleSubmit={this.handleUpdate}
              handleModal={this.handleModalEdit}
              modal={this.state.modalEdit}
              statusSave={this.props.statusSave}
              loadingSave={this.props.loadingSave}
              dataSave={this.props.dataSave}
              config={this.state.config}
              language={this.props.language ? this.props.language : ''}
              types={this.state.types}
              crudTypes={this.state.crudTypes}
            />
            <ModalDelete
              handleSubmit={this.handleDelete}
              handleModal={this.handleModalDelete}
              modal={this.state.modalDelete}
              statusSave={this.props.statusSave}
              loadingSave={this.props.loadingSave}
              dataSave={this.props.dataSave}
              config={this.state.config}
              language={this.props.language ? this.props.language : ''}
            />
          </div>
        );
      } else if (
        this.props.status === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }
    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  language: state.reducer.dashboard.language,
  setting: state.reducer.dashboard.setting,

  datos: state.reducer.accountExtendedProperty.datos,
  loading: state.reducer.accountExtendedProperty.loading,
  loadingTable: state.reducer.accountExtendedProperty.loadingTable,
  status: state.reducer.accountExtendedProperty.status,

  loadingSave: state.reducer.accountExtendedProperty.loadingSave,
  statusSave: state.reducer.accountExtendedProperty.statusSave,
  dataSave: state.reducer.accountExtendedProperty.dataSave,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(accountExtendedPropertyActions, dispatch)
});

AccountExtendedProperty.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountExtendedProperty);



// WEBPACK FOOTER //
// ./source/client/containers/account_extended_property/index.jsx